export default {
  账号设置_th: 'Setting',
  退出登录: 'Logout',
  您好: 'Hello!',
  注册: 'Register',
  登录: 'Log in',
  退出: 'Log Out',
  充值: 'Top up My Account',
  管理账号: 'Manage My Account',
  新手指引: 'New User Tutorial',
  App下载: 'App',
  领券中心: 'Coupon',
  我的企业: 'My Company',
  昨日阅览: 'views yesterday',
  人次: '',
  云采购: 'Cloud Sourcing',
  下载云展动力APP: 'Download APP',
  扫码下载: 'Scan to download',
  数字孪生精准获客平台: 'ACCURATE CLIENT ACCESS PLATFORM ON DIGITAL TWIN TECHNOLOGY',
  密码登录: 'Login with Password',
  验证码登录: 'Login via SMS',
  其他登录方式: 'Or Login With',
  请绑定手机号码: 'Please bind your phone number',
  绑定手机: 'Bind Phone',
  已有账号: 'Have account?',
  去登录: 'Login',
}
